export type FormulaId = "all-risks" | "third-party";

export interface SavingsRow {
  id: string;
  scenario: string;
  withoutRoole: string;
  withRoole: string;
}

const ALL_RISKS_ROWS: SavingsRow[] = [
  {
    id: "vehicule-percute",
    scenario: "Vous percutez un véhicule",
    withoutRoole: "319 € de franchise",
    withRoole: "0 €",
  },
  {
    id: "animal-sauvage",
    scenario: "Vous percutez un animal sauvage",
    withoutRoole: "393 € de franchise",
    withRoole: "0 €",
  },
  {
    id: "vandalisme",
    scenario: "Votre véhicule est vandalisé",
    withoutRoole: "368 € de franchise",
    withRoole: "0 €",
  },
  {
    id: "grele",
    scenario: "Votre véhicule subi la grêle",
    withoutRoole: "312 € de franchise",
    withRoole: "0 €",
  },
  {
    id: "stationnement",
    scenario: "Accrochage en stationnement",
    withoutRoole: "367 € de franchise",
    withRoole: "0 €",
  },
];

const THIRD_PARTY_WITHOUT_ROOLE = "Vous payez les réparations";
const THIRD_PARTY_WITH_ROOLE = "Jusqu'à 500 € d'aide aux réparations";

const THIRD_PARTY_ROWS: SavingsRow[] = [
  {
    id: "vehicule-percute",
    scenario: "Vous percutez un véhicule",
    withoutRoole: THIRD_PARTY_WITHOUT_ROOLE,
    withRoole: THIRD_PARTY_WITH_ROOLE,
  },
  {
    id: "animal-sauvage",
    scenario: "Vous percutez un animal sauvage",
    withoutRoole: THIRD_PARTY_WITHOUT_ROOLE,
    withRoole: THIRD_PARTY_WITH_ROOLE,
  },
  {
    id: "vandalisme",
    scenario: "Votre véhicule est vandalisé",
    withoutRoole: THIRD_PARTY_WITHOUT_ROOLE,
    withRoole: THIRD_PARTY_WITH_ROOLE,
  },
  {
    id: "grele",
    scenario: "Votre véhicule subit la grêle",
    withoutRoole: THIRD_PARTY_WITHOUT_ROOLE,
    withRoole: THIRD_PARTY_WITH_ROOLE,
  },
];

export const SAVINGS_ROWS_BY_FORMULA: Record<FormulaId, SavingsRow[]> = {
  "all-risks": ALL_RISKS_ROWS,
  "third-party": THIRD_PARTY_ROWS,
};
